export enum PanelDisplayMode {
    Allowed = 1,
    NotAllowed = 2,
    Offline = 3
}
